<template>
  <a-select :showSearch="showSearch" v-model="data_value" optionFilterProp="children" :placeholder="placeholder" @change="func_onChange" :filterOption="filterOption" :disabled="disabled">
    <template v-if="optionGroups">
      <a-select-opt-group :key="`key_${group.title}`" v-for="(group) in options" :label="group.title">
          <a-select-option :key="`key_${item.value || item}`" v-for="(item) in group.options" :value="`${group.title}.${item.value || item}`">{{ item.label || item }}</a-select-option>
      </a-select-opt-group>
    </template>
    <template v-else>
      <a-select-option :key="`key_${item.value || item}`" v-for="(item) in options" :value="item.value || item">{{ item.label || item }}</a-select-option>
    </template>
  </a-select>
</template>

<script>
export default {
  name: 'Select',
  props: {
    showSearch: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    options: { type: Array, required: true },
    optionGroups: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: { type: String, default: null }
  },
  data() {
    return {
      data_value: this.value
    }
  },
  methods: {
    func_onChange() {
      this.$emit('input', this.data_value)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  },
  watch: {
    value(newValue) {
      this.data_value = newValue
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.ant-card {
  .ant-select-selection, .ant-select-search {
    background-color: @input-bg;
  }
  .ant-select-selection {
    height: 58px !important;
  }
}
.ant-select {
  min-width: 140px;
  
  .ant-select-search {
    border-radius: @border-radius-base;
  }
  .ant-select-dropdown-menu-item {
    text-transform: capitalize;
  }
  &.ant-select-disabled {
    opacity: 0.5;
    .ant-select-selection {
      background:#403F7A;
    }
  }
}
</style>
